<template>
  <div class="default_layout">
    <router-view class="content"/>
  </div>
</template>

<script>
export default {
}
</script>

<style>

</style>
